import React from 'react';
import SalesTable from './SalesTable';
import genericStyles from "../../Styles/genericStyles.module.css";

const Sales = () => {
  return (
    <div className={genericStyles.mainContainer} >
      <SalesTable />
    </div>
  );
};

export default Sales;
